(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-modal"] && !Shopify.designMode) return;
  try {
    function setupProductMediaModalNavigation(modal) {
    if (modal.dataset.galleryNavigationReady === 'true') return;

    const content = modal.querySelector('.product-media-modal__content');
    const previousButton = modal.querySelector('[data-media-modal-previous]');
    const nextButton = modal.querySelector('[data-media-modal-next]');

    if (!content || !previousButton || !nextButton) return;

    const getItems = () => Array.from(content.querySelectorAll('[data-media-id]'));

    [previousButton, nextButton].forEach((button) => {
      button.addEventListener('pointerup', (event) => event.stopPropagation());
    });

    const activateItem = (item) => {
      const items = getItems();
      items.forEach((media) => media.classList.remove('active'));
      item.classList.add('active');
      content.scrollTo({ top: 0, left: 0 });

      if (item.nodeName === 'DEFERRED-MEDIA' && typeof item.loadContent === 'function') {
        item.loadContent();
      }
    };

    const move = (direction) => {
      const items = getItems();
      if (items.length < 2) return;

      const activeIndex = items.findIndex((item) => item.classList.contains('active'));
      const nextIndex = (activeIndex + direction + items.length) % items.length;
      activateItem(items[nextIndex]);
    };

    previousButton.addEventListener('click', () => move(-1));
    nextButton.addEventListener('click', () => move(1));

    modal.addEventListener('keydown', (event) => {
      if (!modal.hasAttribute('open')) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    const hasMultipleItems = getItems().length > 1;
    previousButton.hidden = !hasMultipleItems;
    nextButton.hidden = !hasMultipleItems;
    modal.dataset.galleryNavigationReady = 'true';
  }

  function initialiseProductMediaModalNavigation(root) {
    root.querySelectorAll('product-modal').forEach(setupProductMediaModalNavigation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseProductMediaModalNavigation(document));
  } else {
    initialiseProductMediaModalNavigation(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseProductMediaModalNavigation(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
